import VisitsTable from './VisitsTable'

export default VisitsTable;